function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFBC00"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF8700"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  d: "M432.46 107.88l52.264-51.889 66.29 66.29-68.595 69.06.578.472a46.85 46.85 0 0 1 17.002 36.123v256.338c0 25.888-20.987 46.875-46.875 46.875H46.874C20.988 531.149 0 510.162 0 484.274V227.908c.003-12.222 7.668-28.44 17.109-36.202 1.69-1.386 21.446-17.304 45.39-36.552V124.9c0-17.256 13.995-31.25 31.25-31.25h45.372c4.003-3.193 7.49-5.986 9.96-7.949C171.25 67.986 207.803 31.15 250 31.15c42.423 0 79.327 37.295 100.908 54.551 2.432 1.933 5.928 4.717 9.962 7.949h45.38c10.979 0 20.637 5.665 26.211 14.23zM406.25 268.03l-13.126 13.215H294.51c-15.742-.303-29.873-9.15-36.953-23.281-2.88-5.781-7.9-6.367-9.931-6.367-2.032 0-7.05.576-9.785 6.045l-7.491 14.98c-6.22 12.48-24.443 11.103-28.789-2.041l-16.435-49.287-10.362 31.133a42.16 42.16 0 0 1-40.039 28.838h-12.099c-8.633 0-15.625-6.992-15.625-15.625s6.992-15.625 15.625-15.625h12.1c4.716 0 8.896-3.008 10.39-7.48l17.764-53.36c3.222-9.58 12.148-16.025 22.246-16.025a23.425 23.425 0 0 1 22.236 16.026l13.555 40.663c19.287-15.81 52.793-9.473 64.453 13.828 1.845 3.692 5.36 6.026 9.14 6.328l31.241.006v-36.178l80.499-79.92V124.9h-312.5v169.277c31.592 25.4 63.77 51.21 84.561 67.714 16.456 13.125 49.023 44.63 71.69 44.258 22.675.362 55.233-31.133 71.689-44.247 20.79-16.505 52.988-42.325 84.56-67.716V268.03zm31.25-31.463v32.473c11.455-9.228 21.855-17.618 31.25-25.186v-15.918c0-4.677-2.061-9.061-5.664-12.04a682.76 682.76 0 0 0-2.8-2.27l-22.786 22.94zM249.999 62.4c-21.171 0-43.525 16.338-61.62 31.25h123.28C293.593 78.728 271.26 62.4 250 62.4zM31.25 227.908v15.946c9.269 7.471 19.99 16.113 31.25 25.176v-73.779c-14.198 11.426-24.335 19.59-25.546 20.586a15.58 15.58 0 0 0-5.703 12.07zM599.715 38.404c9.717 9.706 9.717 25.459 0 35.165l-26.611 26.612-66.289-66.29 26.611-26.61c9.707-9.708 25.46-9.708 35.166 0l31.123 31.123z"
});

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 607 532"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/logo.80c91025.svg";
export { SvgLogo as ReactComponent };